// extracted by mini-css-extract-plugin
export var container = "_5k-0";
export var infoButton = "_5k-1";
export var label = "_5k-3";
export var labelExpanded = "_5k-4";
export var price = "_5k-5";
export var priceExpanded = "_5k-6";
export var title = "_5k-2";